import { Popup } from "react-map-gl";
import { centroid } from "@turf/centroid";

import "./popup.css";
import { DetectionCard } from "../../components";
import { Inference } from "../../types/inferences";

type Props = {
  inference: Inference,
  onClose: () => void;
  includeThumbnail?: boolean;
}

export function InferencePopup({ inference, onClose, includeThumbnail }: Props) {
  const {geometry, properties} = inference;
  const polygonCentroid = centroid(geometry);

  const [lon, lat] = polygonCentroid.geometry.coordinates;

  return(
    <Popup
      key={properties.id}
      anchor="top"
      longitude={lon}
      latitude={lat}
      onClose={onClose}
      closeButton={false}
      maxWidth="250px"
    >
      <DetectionCard inference={inference} includeThumbnail={includeThumbnail} includeDate />
    </Popup>
  );
}
